import { makeStyles, createStyles, hexToRgb, Theme } from '@material-ui/core/styles';
import { UtilityBarStyle, PageStyle } from '../../store/interfaces';
import { BrandColors } from '../../constants';

export const UtilityLinkStyles = makeStyles(() =>
  createStyles({
    utilityLink: (props: UtilityBarStyle) => ({
      paddingLeft: 0,
      '& > li': {
        marginLeft: '30px',
      },
      '& a': {
        color: props.textColor,
        textDecoration: 'none',
        fontWeight: 'bold',
        '&:visited': {
          textDecoration: 'none',
          color: props.textColor,
        },
      },
    }),
    userProfile: (props: UtilityBarStyle) => ({
      color: props.textColor,
      fontWeight: 'bold',
      fontSize: '1rem',
      '& svg': {
        fontSize: '1rem !important',
      },
    }),
    userProfileOpen: {
      boxShadow: `2px 3px 4px ${BrandColors.lightGrey40}`,
    },
    settingsIcon: (props: UtilityBarStyle) => ({
      color: hexToRgb(props.textColor),
      fontSize: '1rem',
      '&:disabled': {
        color: props.textColor,
      },
      pointerEvents: 'auto!important' as any /* eslint-disable-line @typescript-eslint/no-explicit-any */,
      paddingBottom: 0,
      paddingTop: 0,
    }),
    settingsOpen: {
      boxShadow: `2px 3px 4px ${BrandColors.lightGrey40}`,
    },
    languageTitle: {
      paddingRight: '0',
      maxWidth: '105px',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      fontWeight: 'bold',
      '& + .MuiButton-endIcon svg': {
        fontSize: '0.75rem',
      },
    },
    languageIcon: (props: UtilityBarStyle) => ({
      '& path': {
        fill: hexToRgb(props.textColor),
      },
    }),
  }),
);

export const ICPRecordalStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: (props: PageStyle) => ({
      backgroundColor: props.containerColor,
      boxShadow: `0px 0px 4px 1px ${BrandColors.blackWithOpacity25}`,
      borderRadius: '0',
      borderTopLeftRadius: '0.5rem',
      padding: '0.20rem 1rem',
      position: 'absolute',
      bottom: 0,
      right: 0,
      '& a': {
        [theme.breakpoints.down('sm')]: {
          fontSize: '0.72rem',
        },
      },
    }),
    utilityLink: (props: PageStyle) => ({
      '& > a': {
        marginBottom: 16,
        color: props.fontColor,
        fontSize: '0.875rem',
        fontWeight: 500,
        lineHeight: '1.57',
        '&:visited': {
          color: props.fontColor,
        },
      },
    }),
  }),
);
